import React, { useState } from 'react';
import { Card, Button, Modal, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { faCamera, faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';

const UploadDropzone = () => {
  const { t } = useTranslation();
  const { getRootProps, getInputProps, acceptedFiles } = useDropzone({
    accept: {'image/*': []}
  });
  return (
    <div>
      <div
        {...getRootProps()}
        className="border border-2 border-dashed rounded-3 p-5 text-center bg-light cursor-pointer"
      >
        <input {...getInputProps()} />

        <FontAwesomeIcon
          icon={faCloudUploadAlt}
          size="2x"
          className="text-primary mb-3"
        />

        <h6 className="fw-medium mb-1">{t('dropYourImagesHere')}</h6>

        <p className="text-muted fs-10 mb-0">{t('orClickToBrowseFiles')}</p>
      </div>

      {acceptedFiles.length > 0 && (
        <div className="mt-3">
          <h6 className="fw-medium fs-10">{t('selectedFiles')}</h6>
          <ul className="mb-0 fs-10">
            {acceptedFiles.map((file) => (
              <li key={file.path}>
                {file.path} - {Math.round(file.size / 1024)} KB
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

const InspectionLog = () => {
  const [showUpload, setShowUpload] = useState(false);
  const { t } = useTranslation();
  return (
    <Card className="mb-0 shadow-none">
      <Card.Body className='p-0'>

        {/* Timeline Wrapper Card */}
        <Card className="border shadow-none">
          <Card.Body>

            {/* NEW: Inner Card Header with Heading + Upload Button */}
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h3 className="mb-0 fw-medium font-size-15">
                {t('inspectionLog')}
              </h3>
              {/* <Button
                variant="falcon-default"
                size="sm"
                className="shadow-none border fw-medium font-size-13"
                onClick={() => setShowUpload(true)}
              >
                <FontAwesomeIcon icon="upload" className="me-2" />
                {t('upload')}
              </Button> */}
            </div>

            {/* <div className="position-relative">
              <div className="position-relative mb-3">
                <div className="position-absolute border-start border-2 border-300 timeline-vertical-line"/>
                <div className="d-flex gap-3">
                  <div className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 fw-bold timeline-avatar">
                    MJ
                  </div>

                  <Card className="flex-grow-1 border shadow-none card-bg-light-blue">
                    <Card.Body className="p-3">
                      <div className="d-flex justify-content-between align-items-start mb-1 flex-wrap gap-2">
                        <div className="d-flex align-items-center gap-2 flex-grow-1 min-w-0">
                          <p className="mb-0 text-truncate text-muted fw-medium font-size-13 max-w-150">
                            Marcus Johnson
                          </p>

                          <span className="badge badge-subtle bg-info px-2 py-1 fw-normal font-size-12 flex-shrink-0">
                            {t('employee')}
                          </span>
                        </div>
                        <span className="badge badge-subtle bg-success px-3 py-1 fw-medium font-size-12 flex-shrink-0">
                          {t('completed')}
                        </span>
                      </div>

                      <span className="text-muted d-block mb-2 fw-normal font-size-12">
                        <FontAwesomeIcon icon="clock" className="me-1" />
                        {t('january')} 28, 2025, 9:04
                      </span>

                      <p className="mb-2 mt-3 fw-normal font-size-13">
                        {t('midExecutionQualityCheck')}
                      </p>

                      <div>
                        <span className="text-muted mb-2 d-flex align-items-center fw-normal font-size-12">
                          <FontAwesomeIcon icon={faCamera} className="me-1" />3 {t('photos')}
                        </span>
                        <div className="d-flex gap-2 flex-wrap">
                          {[1, 2, 3].map((i) => (
                            <div
                              key={i}
                              className="rounded bg-secondary bg-opacity-10 d-flex align-items-center justify-content-center border card-hover shadow-none media-thumb-box"
                            >
                              <FontAwesomeIcon
                                icon="image"
                                className="text-secondary opacity-50"
                                size="2x"
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>

              <div className="position-relative mb-3">
                <div className="d-flex gap-3">
                  <div className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 fw-bold timeline-avatar">
                    MJ
                  </div>

                  <Card className="flex-grow-1 border shadow-none card-bg-light-blue">
                    <Card.Body className="p-3">
                      <div className="d-flex justify-content-between align-items-start mb-1 flex-wrap gap-2">
                        <div className="d-flex align-items-center gap-2 flex-grow-1 min-w-0">
                          <p className="mb-0 text-truncate text-muted fw-medium font-size-13 max-w-150">
                            Marcus Johnson
                          </p>

                          <span className="badge badge-subtle bg-info px-2 py-1 fw-normal font-size-12 flex-shrink-0">
                            {t('employee')}
                          </span>
                        </div>
                        <span className="badge badge-subtle bg-success px-3 py-1 fw-medium font-size-12 flex-shrink-0">
                          {t('pass')}
                        </span>
                      </div>

                      <span className="text-muted d-block mb-2 fw-normal font-size-12">
                        <FontAwesomeIcon icon="clock" className="me-1" />
                        {t('january')} 28, 2025, 9:04
                      </span>

                      <p className="mb-2 mt-3 fw-normal font-size-13">
                        {t('midExecutionQualityChecked')}
                      </p>

                      <div>
                        <span className="text-muted mb-2 d-flex align-items-center fw-normal font-size-12">
                          <FontAwesomeIcon icon={faCamera} className="me-1" />2 {t('photos')}
                        </span>
                        <div className="d-flex gap-2 flex-wrap">
                          {[1, 2].map((i) => (
                            <div
                              key={i}
                              className="rounded bg-secondary bg-opacity-10 d-flex align-items-center justify-content-center border card-hover shadow-none media-thumb-box"
                            >
                              <FontAwesomeIcon
                                icon="image"
                                className="text-secondary opacity-50"
                                size="2x"
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </div> */}

            <div className="text-center py-5">{t("NoDataFound")}</div>

          </Card.Body>
        </Card>

        {/* Upload Modal */}
        <Modal
          show={showUpload}
          onHide={() => setShowUpload(false)}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title className="fw-medium">
              {t('uploadInspectionImages')}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <UploadDropzone />
          </Modal.Body>

          <Modal.Footer>
            <Button variant="falcon-default" onClick={() => setShowUpload(false)}>
              {t('cancel')}
            </Button>

            <Button variant="primary">{t('submit')}</Button>
          </Modal.Footer>
        </Modal>

      </Card.Body>
    </Card>
  );
};

export default InspectionLog;
